module.exports = __webpack_public_path__ + "static/media/icon_proveedores.9dba7da0.png";